export type ENVIRONMENTS = 'dev' | 'stage' | 'prod'
  | 'prodCheckout' | 'stageCheckout' | 'devCheckout'
  | 'devCentral' | 'stageCentral' | 'prodCentral';